export const QUICKBOOKS_AUTO_APPLY_CREDIT_ENABLED =
  'QUICKBOOKS_AUTO_APPLY_CREDIT_ENABLED'

export type SyncErrorEntityAddress = {
  line1?: string | null
  line2?: string | null
  city?: string | null
  postCode?: string | null
  state?: string | null
  country?: string | null
}

/**
 * The record that failed, as the integration saw it. `snapshotType` is the
 * backend's discriminator; only customers are described today.
 */
export type SyncErrorCustomerSnapshot = {
  snapshotType: 'CUSTOMER'
  name?: string | null
  address?: SyncErrorEntityAddress | null
}

export type SyncErrorQuoteSnapshot = {
  snapshotType: 'QUOTE'
  name?: string | null
  quoteId?: string | null
  quoteNumber?: string | null
  status?: string | null
  customerName?: string | null
}

export type SyncErrorCreditNoteSnapshot = {
  snapshotType: 'CREDIT_NOTE'
  name?: string | null
  creditNoteNumber?: string | null
  creditNoteId?: string | null
}

export type SyncErrorInvoiceSnapshot = {
  invoiceId: string
  invoiceNumber?: string | null
}

export type SyncErrorPaymentSnapshot = {
  snapshotType: 'PAYMENT'
  name?: string | null
  paymentId?: string | null
  relatedInvoices?: SyncErrorInvoiceSnapshot[]
  affectedInvoice?: SyncErrorInvoiceSnapshot | null
  invoiceId?: string | null
  invoiceNumber?: string | null
}

export type SyncErrorEntitySnapshot =
  | SyncErrorCustomerSnapshot
  | SyncErrorQuoteSnapshot
  | SyncErrorCreditNoteSnapshot
  | SyncErrorPaymentSnapshot

export type SyncErrorTaskInput = {
  entityType: string
  externalEntityType: string
  externalService: string
  externalId?: string
  externalAccountId?: string
  sequenceEntityId?: string
  direction: string
  errorCode: string
  errorMessage: string
  entitySnapshot?: SyncErrorEntitySnapshot | null
  syncErrorKey: string
}

import { FailingFieldProblem } from 'lib/integrations/syncErrorFields'

export type {
  FailingField,
  FailingFieldGroup,
  FailingFieldProblem
} from 'lib/integrations/syncErrorFields'

export type FailingFieldProblemMix = FailingFieldProblem | 'MIXED'

/** One line of the record card's address: either a value, or the label of a slot at fault. */
export type RecordAddressLine = {
  field: string
  text: string
  isPlaceholder: boolean
}
